"use client";

import { Cpu, TrendingUp, Upload, Zap } from "lucide-react";
import { useJsonTranslation } from "@/hooks/useJsonTranslation";

const steps = [
  {
    step: "01",
    icon: Upload,
    titleKey: "steps.upload.title",
    descKey: "steps.upload.description",
  },
  {
    step: "02",
    icon: Cpu,
    titleKey: "steps.analyzes.title",
    descKey: "steps.analyzes.description",
  },
  {
    step: "03",
    icon: Zap,
    titleKey: "steps.assets.title",
    descKey: "steps.assets.description",
  },
  {
    step: "04",
    icon: TrendingUp,
    titleKey: "steps.results.title",
    descKey: "steps.results.description",
  },
];

export function HowItWorks() {
  const { t } = useJsonTranslation("HomeHowItWorks");

  return (
    <div
      data-home-block="process-flow"
      className="relative px-5 py-6 sm:px-7 sm:py-8"
    >
      <div>
        <div className="mb-12 text-center">
          <div className="text-leaf-600 dark:text-leaf-400 mb-4 text-[11px] font-semibold tracking-[0.32em] uppercase">
            {t("eyebrow")}
          </div>
          <h2 className="font-home-display text-foreground text-3xl font-semibold tracking-normal text-balance md:text-4xl lg:text-5xl">
            {t("title")}
          </h2>
          <p className="text-muted-foreground/70 mt-5 text-lg text-pretty">
            {t("subtitle")}
          </p>
        </div>

        <div className="relative grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {/* Connecting line (desktop only, behind cards) */}
          <div
            className="from-leaf-500/0 via-leaf-500/40 to-leaf-500/0 pointer-events-none absolute top-[5.5rem] right-[4%] left-[4%] hidden h-px bg-gradient-to-r lg:block"
            aria-hidden="true"
          />

          {steps.map((item, i) => (
            <div
              key={i}
              className="uni-card group relative z-10 overflow-hidden text-center"
            >
              {/* Step number watermark */}
              <div className="font-display text-foreground/[0.05] pointer-events-none absolute top-3 right-4 text-6xl leading-none font-black select-none">
                {item.step}
              </div>

              {/* Step chip */}
              <div className="text-leaf-600 dark:text-leaf-400 border-leaf-500/20 bg-leaf-500/10 relative z-10 mx-auto mb-5 inline-flex items-center rounded-full border px-3 py-0.5 text-[10px] font-bold tracking-[0.18em] uppercase">
                {t("stepLabel", { number: item.step })}
              </div>

              <div className="relative flex flex-col items-center">
                <div className="bg-surface-success border-surface-success-border text-leaf-700 dark:text-leaf-300 mb-5 flex h-14 w-14 items-center justify-center rounded-2xl border shadow-[0_12px_32px_-16px_rgba(52,211,153,0.6)] transition-transform duration-300 group-hover:scale-110">
                  <item.icon className="h-7 w-7" />
                </div>
                <h3 className="font-display text-foreground mb-2.5 text-lg font-semibold">
                  {t(item.titleKey)}
                </h3>
                <p className="text-muted-foreground mx-auto max-w-xs text-sm leading-relaxed">
                  {t(item.descKey)}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
